<template>
    <div class="order-detail-page" :class="{'no-express': orderDetail.status == 1}">
        <van-sticky>
            <van-nav-bar
                :style="{'paddingTop':statusBarHeight,'backgroundColor':'#FFFFFF'}"
                title="订单详情"
                left-arrow
                @click-left="goBack"
            />
        </van-sticky>
        <div class="order-status-box">
             <!-- v-if="orderDetail.refundApplicationState === null" -->
            <div v-if="orderDetail.refundApplicationState != 7">
                <p class="status-text">
                    <i :class="`icon icon-order-status-${getOrderStatusText(orderDetail.status, addressInfo.deliveryStatus,  'icon')}`" />
                    {{getOrderStatusText(orderDetail.status, addressInfo.deliveryStatus,  'label')}}
                </p>
                <p v-if="addressInfo.deliveryStatus == 4 && addressInfo.receiveTime !== null && orderDetail.refundApplicationState === null" class="status-tips">
                    还剩<van-count-down @finish="onTimmerFinish(1)" :time="getTime(addressInfo.receiveTime)" format="DD天HH时mm分ss秒" />自动确认收货
                </p>
                <p v-else-if="orderDetail.status == 0" class="status-tips">
                    剩余付款时间 <van-count-down @finish="onTimmerFinish(2)" :time="getTime(orderDetail.expireTime)" format="HH时mm分ss秒" />，超时订单将自动关闭
                </p>
                <p class="status-tips" v-else>
                    {{getOrderStatusText(orderDetail.status, addressInfo.deliveryStatus,'tips')}}
                </p>
            </div>
            <div v-else>
                <p class="status-text">
                    <i class="icon icon_order_status_3" />
                    已关闭
                </p>
                <p class="status-tips" >
                   售后/退款完成 订单关闭
                </p>
            </div>
        </div>
        <div class="address-info-box">
            <div class="name-phone">
                <span>{{addressInfo.title}}</span>
            </div>
            <div class="address">
                {{addressInfo.label}}
            </div>
        </div>
        <div class="goods-info-box">
            <goodsCard v-for="(goodsDetail,index) in orderDetail.goodsList" :key="index" :card-data="{
                ...goodsDetail,
                sku: (goodsDetail.skuInfo || []).join(',')
            }" />
            <div class="goods-info-text">
                <p class="goods-info-item">商品金额 <span>¥ {{orderDetail.goodsList && orderDetail.goodsList[0].salePrice || 0}}</span></p>
                <p class="goods-info-item">运费 <span>{{orderDetail.postMoney>0? `¥ ${orderDetail.postMoney}` : '包邮'}}</span></p>
                <p class="goods-info-item" v-if="orderDetail.orderRemark">订单备注 <span class="remark-text">{{orderDetail.orderRemark}}</span></p>
                <p class="goods-info-item">实付款 <span class="price-num">¥ {{orderDetail.realPay}}</span></p>
            </div>
            
            <div class="goods-refund-button-box" v-if="orderDetail.refundApplicationState!==null||(![0,8,9].includes(orderDetail.status)&&orderDetail.canRefund)">
                <div class="goods-refund-button" v-if="!orderDetail.exchangeTag">
                    <div class="refund-prograss">
                        <!-- 待处理 -->
                        <template v-if="orderDetail.refundApplicationState === 0">
                            退款申请审核中
                        </template>
                        <!-- 待退货 -->
                        <template v-else-if="orderDetail.refundApplicationState === 1">
                            请将商品寄回并填写退货单号
                        </template>
                        <!-- 退货中 -->
                        <template v-else-if="orderDetail.refundApplicationState === 2">
                            货品已寄回，待售后确认
                        </template>
                        <!-- 待退款 -->
                        <template v-else-if="orderDetail.refundApplicationState === 4">
                            待售后确认退款
                        </template>
                        <!-- 退款中 -->
                        <template v-else-if="orderDetail.refundApplicationState === 5">
                            等待财务确认退款中
                        </template>
                        <!-- 已完成 -->
                        <template v-else-if="orderDetail.refundApplicationState === 7">
                            售后处理已完成
                        </template>
                        <!-- 已拒绝 -->
                        <template v-else-if="orderDetail.refundApplicationState === 9">
                            退款已拒绝
                        </template>
                    </div>
                    <van-button plain type="primary" class="refund-btn" v-if="orderDetail.refundApplicationState===null&&orderDetail.canRefund" @click.stop="goRefund">退款</van-button>
                    <van-button plain type="primary" class="detail-btn" v-else-if="orderDetail.refundApplicationState!==null" @click.stop="goRefundDetail">退款/售后进度</van-button>
                </div>
                
            </div>
        </div>
        <div class="order-info-box">
            <p>订单编号： <span>{{orderDetail.orderNo}}</span></p>
            <p>创建时间： <span>{{orderDetail.createTime}}</span></p>
            <p v-if="orderDetail.status != 0">{{orderDetail.exchangeTag? '兑换时间：' :'付款时间：'}} <span>{{orderDetail.paidTime}}</span></p>
        </div>
        <div class="serve-box" @click="handleServe">
            <div class="serve-box-qm">
                <i class="icon icon-serve" />联系客服
            </div>
        </div>
        <div class="bottom-bar" 
            v-if="orderDetail.status === 0 || addressInfo.deliveryStatus === 4"
            :style="{'paddingBottom':bottomSafeHeight,'backgroundColor':'#FFFFFF'}"
        >
            <div class="btn-box" v-if="orderDetail.status == 0">
                <van-button plain type="primary" @click="handleCancalOrder(orderDetail.orderNo)">取消订单</van-button>
                <van-button type="primary" @click="handlePayOrder(orderDetail)">去支付</van-button>
            </div>
            <div v-else class="btn-box">
                <van-button plain type="primary" :to="`/order/express/${orderDetail.orderNo}`">查看物流</van-button>
                <van-button v-if="orderDetail.refundApplicationState != 7" type="primary" @click="handleConfirm(orderDetail.orderNo)">确认收货</van-button>
            </div>
        </div>
    </div>
</template>
<script>
import { Dialog } from 'vant';
import { orderStatusText, deliveryStatusText } from '../config/enum';
import goodsCard from '../components/card.vue'
export default {
    components: {
        goodsCard,
    },
    data() {
        return {
            isWechat: this.$publicFn.getUserAgent() === 'wechat',
            statusBarHeight: 0,
            bottomSafeHeight: 0,
            orderNo: this.$route.params.orderNo,
            orderDetail: {},
            goodsDetail: {},
            addressInfo: {},
            orderStatusText,
            deliveryStatusText,
            type: this.$route.query.type,
            isApp:false,
        }
    },
    created () {
        this.setCompatible();
        this.getOrderDetail();
        this.$WDJSBridge.useGetAppVersion().then(res=>{
            console.log('获取版本号成功', res)
            this.isApp = res?true:false;
        }).catch(err=>{
            console.log('获取版本号失败', err)
        })
    },
    methods: {
        setCompatible() {
            if(localStorage.getItem('type') == 'iOS') {
                this.statusBarHeight = `${localStorage.getItem("statusBarHeight")|| 0}px`;
                this.bottomSafeHeight = `${localStorage.getItem("bottomSafeHeight")|| 0}px`;
            }
        },
        goBack() {
            if(this.$isapp && this.$publicFn.getUserAgent(false) == 'ios') {
                this.$WDJSBridge.useBack()
            } else {
                this.$router.go(-1);
            }
        },
        getOrderDetail() {
            this.$api.entityOrder.getOrderDetail({
                orderNo: this.orderNo,
            }).then((res)=>{
                if(res.success) {
                    this.orderDetail = res.data;
                    this.goodsDetail = res.data.goodsList[0];
                    
                    const {
                        receiver, addr, province, city, area, mobile, deliveryStatus, receiveTime,
                    } = res.data.orderAddr;
                    this.$set(this.addressInfo, 'title', `${receiver} ${mobile}`);
                    this.$set(this.addressInfo, 'label', `${province}${city}${area}${addr}`);
                    this.$set(this.addressInfo, 'deliveryStatus', deliveryStatus);
                    this.$set(this.addressInfo, 'receiveTime', receiveTime);
                }
            })
        },
        getOrderStatusText(status, deliveryStatus, key) {
            const result = this.deliveryStatusText[deliveryStatus] || this.orderStatusText[status];
            return result? result[key] : '';
    
        },
        handleServe() {
            this.$sensors.track('contact', {
                contact_type: '客服咨询',
            })
            if(this.isApp){
                this.$WDJSBridge.useNewPage(JSON.stringify({
                    path:'/customerService',
                    title:'客服'
                })).then(res=>{
                    console.log('客服成功', res)
                }).catch(err=>{
                    console.log('客服失败', err)
                })
            }else{
                window.qimoChatClick();
            }
        },
        onConfirm(orderNo) {
            this.$api.entityOrder.confirmDeliverSuccess({
                orderNo,
            }).then((res)=>{
                if(res.success) {
                    this.onReload();
                }
            })
        },
        handleConfirm() {
            Dialog.confirm({
                title: '确认收货',
                message: '确认收货后，订单交易完成，钱款将立即到达商家账户',
                width: '15rem',
                theme: 'app-theme',
                confirmButtonText: '确认收货',
                confirmButtonColor: '#1F94FF'
            })
            .then(() => {
                this.onConfirm(this.orderNo)
            })
        },
        onCancelOrder(orderNo) {
            this.$api.entityOrder.cancelOrder({
                orderNo,
            }).then((res)=>{
                if(res.success) {
                    this.onReload();
                }
            })
        },
        handleCancalOrder(orderNo) {
            Dialog.confirm({
                title: '取消订单',
                message: '订单还未付款，确定要取消吗？',
                width: '15rem',
            })
            .then(() => {
                var params = {
                    cancel_type:'主动取消',
                    order_id:this.orderDetail.id,
                    commodity_quantity:1,
                    commodity_id:this.orderDetail.goodsList[0].id,
                    commodity_type:this.orderDetail.goodsList[0].goodsKinds,
                    aff_institution_id:this.orderDetail.branchId,
                    commodity_name:this.orderDetail.goodsList[0].name,
                    original_price:this.orderDetail.goodsList[0].basePrice,
                    current_price:this.orderDetail.goodsList[0].salePrice,
                    receiver_name:this.orderDetail.orderAddr.receiver,
                    receiver_province:this.orderDetail.orderAddr.province,
                    receiver_city:this.orderDetail.orderAddr.city,
                    receiver_area:this.orderDetail.orderAddr.area,
                    receiver_address:this.orderDetail.orderAddr.addr,
                    receiver_phone_number:this.orderDetail.orderAddr.mobile,
                }
                this.$sensors.track('cancel_order',params)
                this.onCancelOrder(orderNo)
            })
        },
    
        handlePayOrder({id, orderNo, goodsList, realPay, orderType}) {
            // const {id} = goodsList[0]
            if(this.lock) {
                return false;
            }
            this.lock = true;
            // alert(orderNo)
              // alert(res.data.orderNo)
              this.$api.home
                .prePayOrder({
                    // 调用订单号
                    data: {
                        orderId: id,
                        orderNo,
                        totalMoney: realPay,
                        payInfoDesc: "",
                        scene: 4,
                        agentId: localStorage.getItem('detailAgentId') || ''
                    }
                })
                .then(async(prePayRes) => {
                    if (prePayRes.message === "success") {
                        let url  = ''
                        let locationHref = window.location.href
                        if (locationHref.includes('testing')) {
                            url = 'pay.testing3.wdeduc.com'
                        } else if (locationHref.includes('fat')) {
                            url = 'pay.fat.wdeduc.com'
                        } else if (locationHref.includes('uat')) {
                            url = 'pay.uat.wdeduc.com'
                        } else  {
                            url = 'pay.wdeduc.com'
                        }
                        // 跳转支付系统，在返回使用的标记
                        localStorage.setItem('hasJumpCashier', 1)
                        const successBackUrl = encodeURIComponent(window.location.protocol+'//'+window.location.hostname)
                        const backUrl = this.isApp ? window.location.origin + `/payComplete` : window.location.origin + `/myPage`
                        const data = {
                            key: orderNo,
                            value: JSON.stringify({
                                orderNo,
                                organ: localStorage.getItem("organ"),
                                token: localStorage.getItem("token"),
                                actor: localStorage.getItem("actor"),
                                branch: localStorage.getItem("branch"),
                                platform: localStorage.getItem("type"),
                                // backUrl: window.location.origin + `/order/detail/${orderNo}?goodsId=${id}`,
                                backUrl,
                                iOSstatusBarHeight: localStorage.getItem('statusBarHeight'),
                                iOSbottomSafeHeight: localStorage.getItem('bottomSafeHeight'),
                                id,
                                // referId: this.goodsList.referId,
                                orderType,
                                successBackUrl: successBackUrl,
                                // CSuccessBackUrl: window.location.origin + `/payComplete?backUrl=/order/detail/${orderNo}&goodsId=${id}`
                                CSuccessBackUrl: backUrl
                            })
                        }

                        let result = await this.$api.orderPage.jumpPaySaveParams(data)
                        // alert(result.code+'----'+this.handelPaylist.orderNo)
                        // if(result.success) {
                        //     window.location.href = `https://${url}/cashier?orderNo=${this.handelPaylist.orderNo}`
                        // }

                        window.location.href =
                            "https://" +
                            `${url}` +
                            "/cashier?orderNo=" +
                            `${orderNo}` +
                            "&organ=" +
                            localStorage.getItem("organ") +
                            "&token=" +
                            localStorage.getItem("token") +
                            "&actor=" +
                            localStorage.getItem("actor") +
                            "&branch=" +
                            localStorage.getItem("branch") +
                            "&backUrl=" +
                            backUrl +
                            "&id=" +
                            id + 
                            "&orderType=" +
                            `${orderType}` +
                            '&successBackUrl=' + successBackUrl +
                            "&type=" +
                            'pay3'
                        this.lock = false;
                    } else {
                        this.lock = false;
                    }
                },()=>{
                    this.lock = false;
                });
        },
        goRefund(){
            console.log(this.orderDetail,'orderDetail')
            if(this.orderDetail.deliveryStatus == 3){
                

                this.$router.push({
                  path:'/submitRefund',
                  query:{
                    id:this.orderDetail.goodsList[0].id, //  商品id
                    orderId:this.orderDetail.id, //订单id
                    type:0,
                    orderNo:this.orderDetail.orderNo, // 订单编号
                    url:'orderDetail',
                    backPath:this.$route.params.backPath
                  }
                })
                
            }else {
                this.$router.push({
                  path:'/shippedRefund',
                  query:{
                    id:this.orderDetail.goodsList[0].id, //  商品id
                    orderId:this.orderDetail.id, //订单id
                    orderNo:this.orderDetail.orderNo,
                    url:'orderDetail'
                  }
                })
            } 
            
        },
        goRefundDetail(){
            this.$router.push({
                path:'/refundSchedule',
                query:{
                    id:this.orderDetail.goodsList[0].id, //  商品id
                    orderId:this.orderDetail.id, //订单id
                    orderNo:this.orderDetail.orderNo,
                    url:'orderDetail',
                    backPath:this.$route.params.backPath
                }
            })
        },
        getTime(time) {
            const now = new Date().getTime();
            const endTime = new Date(this.$publicFn.mobileDateFormat(time)).getTime();
            const result = endTime - now;
            return result;
        },
        onTimmerFinish(type) {
            if(type === 2) {
                var params = {
                    cancel_type:'过期取消',
                    order_id:this.orderDetail.id,
                    commodity_quantity:1,
                    commodity_id:this.orderDetail.goodsList[0].id,
                    commodity_type:this.orderDetail.goodsList[0].goodsKinds,
                    aff_institution_id:this.orderDetail.branchId,
                    commodity_name:this.orderDetail.goodsList[0].name,
                    original_price:this.orderDetail.goodsList[0].basePrice,
                    current_price:this.orderDetail.goodsList[0].salePrice,
                    receiver_name:this.orderDetail.orderAddr.receiver,
                    receiver_province:this.orderDetail.orderAddr.province,
                    receiver_city:this.orderDetail.orderAddr.city,
                    receiver_area:this.orderDetail.orderAddr.area,
                    receiver_address:this.orderDetail.orderAddr.addr,
                    receiver_phone_number:this.orderDetail.orderAddr.mobile,
                }
                this.$sensors.track('cancel_order',params)
                this.onCancelOrder(this.orderNo)
            } else {
                this.onConfirm(this.orderNo)
            }
        },
        onReload() {
            this.getOrderDetail();
        }
    },
}
</script>

<style lang="less">
    body,html {
        background-color: #F8FAFC;
    }
    .van-dialog__footer {
        width: 100%;
    }
</style>
<style lang="less" scoped>
.px2rem(@name,@px){
    @{name}: @px / 37.5px * 1rem
}

.goods-refund-button-box{
    
    // margin-top: 16px;
    // padding: 0 32px;
    .goods-refund-button{
        display: flex;
        justify-content: space-between;
        border-top: 1px solid #eaeaea;
        width: 100%;
        padding: 16px 0;
        align-items: center;
        .refund-prograss{
            font-size: 28px;
            color: rgb(51, 51, 51);
        }
    }
    ::v-deep{
        .van-button{
            //   .px2rem(width,160);
            .px2rem(height,64);
            .px2rem(border-radius,44);
            border: 0.02667rem solid #D8D8D8;
            .px2rem(font-size,30);
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
        }
    } 
   .detail-btn{
        border-color:#1F94FF;
        color:#1F94FF;
    }
}
.order-detail-page {
    padding-bottom: 227px;
    &.no-express {
        padding-bottom: 67px;
    }
    ::v-deep {
        .van-nav-bar .van-icon {
            color: #30333B;
            .px2rem(font-size, 34);
        }
    }
}
.order-status-box {
    background: #1F94FF url('../asset/images/order_bg.png') no-repeat center /100% 100%;
    padding: 40px 32px;
    .status-text {
        font-size: 36px;
        color: #fff;
        margin-bottom: 21px;
        display: flex;
        align-items: center;
        line-height:40px;
        .icon {
            width: 40px;
            height: 40px;
            background-position: center center;
            background-size: 100% 100%;
            background-repeat: no-repeat;
            margin-right: 8px;
            &.icon-order-status-1 {
                background-image: url(../asset/images/icon_order_status_1.png);
            }
            &.icon-order-status-2 {
                background-image: url(../asset/images/icon_order_status_2.png);
            }
            &.icon-order-status-3 {
                background-image: url(../asset/images/icon_order_status_3.png);
            }
            &.icon-order-status-4 {
                background-image: url(../asset/images/icon_order_status_4.png);
            }
        }
        .icon_order_status_10 {
            background-image: url(../asset/images/icon_order_status_10.png);
        }
    }
    .status-tips {
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFF;
        line-height: 40px;
        ::v-deep {
            .van-count-down {
                display: inline-block;
                color: #FFF;
                .px2rem(font-size, 28);
                .px2rem(line-height, 40);
                font-family: monospace 
            }
        }
    }
}
.address-info-box {
    padding: 32px;
    position: relative;
    margin-bottom: 16px;
    background-color: #fff;
    box-sizing: border-box;
    overflow: hidden;
    &:after {
        content: '';
        position: absolute;
        left: -16px;
        right: -16px;
        bottom: 0;
        height: 6px;
        background: url(../asset/images/line.png) repeat center center /100% 6px;
    }
    .name-phone {
        font-family: AvenirNext-DemiBold, AvenirNext;
        font-weight: 500;
        color: #333333;
        line-height: 41px;
        margin-bottom: 13px;
        font-size: 30px;
    }
    .address {
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 37px;
        font-size: 26px;
    }
}
.goods-info-box {
    padding: 32px 32px 0;
    margin-bottom: 16px;
    background-color: #fff;
    .goods-info-text {
        border-top: 1px solid #eaeaea;
        padding: 16px 0;
    }
    .goods-info-item {
        display: flex;
        justify-content: space-between;
        padding: 16px 0;
        font-size: 28px;
        color: #999;
        span {
            color: #333;
            font-size: 28px;
            &.price-num {
                color: #FE5746;
                font-weight: 600;
                font-size: 32px;
            }
        }
        .remark-text{
            color:#999999;
            max-width: 450px;
            text-align:right;
        }
    }
}
.order-info-box {
    padding: 22px 32px;
    background-color: #fff;
    p {
        padding: 16px 0;
        display: flex;
        justify-content: space-between;
        color: #999;
        font-size: 28px;
        span {
            color: #333;
        }
    }
}
.serve-box {

    color: #333;
    font-size: 22px;
    background-color: #fff;
    padding: 0 32px;
    box-sizing: border-box;
    .serve-box-qm {
        border-top: 1px solid #eaeaea;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 104px;
        .icon-serve {
            width: 40px;
            height: 40px;
            display: inline-block;
            background: url(../asset/images/icon_serve.png) no-repeat center center /100% 100%;
            margin-right: 8px;
        }
    }
    
}
.bottom-bar {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 8px 16px;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-end;
    background-color: #fff;
    .btn-box {
        padding-bottom: 8px;
    }
    .van-button {
        color: #fff;
        border-radius: 22px;
        margin-left: 12px;
        padding: 0 25px;
        height: 40px;
    }
    .van-button--primary.van-button--plain {
        border-color: #D8D8D8 ;
        background-color: transparent;
        color: #666;
    }
    .van-button--primary {
        border-color: #FE5746 ;
        background-color: #FE5746;
    }
}

</style>